<div class="header">
    <h2 mat-dialog-title>DTC: {{this.rowData.message}}</h2>
    <mat-dialog-actions>
        <button mat-icon-button color="primary" mat-dialog-close class="closeButton">
            <mat-icon>close</mat-icon>
        </button>
    </mat-dialog-actions>
</div>
<mat-dialog-content>
    <ng-container *ngIf="this.initialized == false && this.noECU == false">
        <div class="loading">
            <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
    </ng-container>
    <ng-container *ngIf="this.initialized && this.noECU == false">
        <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="Label">
                <th mat-header-cell *matHeaderCellDef>Label</th>
                <td mat-cell *matCellDef="let element">{{ element.label }}</td>
            </ng-container>
    
            <ng-container matColumnDef="Info">
                <th mat-header-cell *matHeaderCellDef>Info</th>
                <td mat-cell *matCellDef="let element">{{ element.info }}</td>
            </ng-container>
    
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        </table>
    </ng-container>
    <ng-container *ngIf="this.noECU">
        {{"MESSAGES.UNKNOWN_ECU" | translate}}
    </ng-container>
</mat-dialog-content>

